export default __webpack_public_path__ + "static/media/associate2.6d79a43c.svg";